var React = require('react');

function Gallery (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.38,1.2A7.63,7.63,0,1,0,17,8.83,7.63,7.63,0,0,0,9.38,1.2ZM6.91,12.46V5.19L13,8.83Z"}));
}

Gallery.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Gallery;

Gallery.default = Gallery;
